import { Lifecycle, scoped } from 'tsyringe';
import { viewModelMetadata } from '../metadata/ViewModelMetadata';
export function ViewModel(ParentViewModel) {
    return (target) => {
        if (ParentViewModel) {
            viewModelMetadata.setParentViewModel(ParentViewModel, target);
        }
        scoped(Lifecycle.ContainerScoped)(target);
    };
}
